// App version — displayed in Header and Login screen
// Bump this on each deploy to confirm users see latest build
export const APP_VERSION = '3.4.3';
